import React from 'react';
import { z } from 'zod';
import { Nullable } from 'global';
import { useForm } from 'react-hook-form';
import { InputField } from 'components/form';
import { Button, Stack } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';

const noteFormSchema = z.object({
  subject: z.string().min(1).max(300),
  content: z.string().min(1).max(1000),
});

type NoteActivityFormValues = z.infer<typeof noteFormSchema>;

interface Props {
  isEdit: boolean;
  onCancel: VoidFunction;
  isSubmitting: boolean;
  initialValues: Nullable<NoteActivityFormValues>;
  onSubmit: (formValues: NoteActivityFormValues) => Promise<void>;
}

export const NoteActivityForm = ({ isEdit, onSubmit, onCancel, isSubmitting, initialValues }: Props) => {
  const form = useForm<NoteActivityFormValues>({
    resolver: zodResolver(noteFormSchema),
    defaultValues: initialValues ?? { subject: '', content: '' },
  });

  return (
    <Stack gap="1rem">
      <Stack gap="1rem">
        <InputField
          name="subject"
          label="Note Subject"
          control={form.control}
          inputProps={{ required: true, variant: 'outlined' }}
        />

        <InputField
          name="content"
          control={form.control}
          inputProps={{
            minRows: 5,
            required: true,
            multiline: true,
            variant: 'outlined',
            placeholder: 'Add a note',
          }}
        />
      </Stack>

      <Stack direction="row" gap="1rem">
        <Button loading={isSubmitting} type="submit" variant="contained" onClick={form.handleSubmit(onSubmit)}>
          {isEdit ? 'Update note' : 'Create note'}
        </Button>

        <Button disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
      </Stack>
    </Stack>
  );
};
